import React, { PureComponent } from "react";
import { Wrapper, Row, Copy, Spin, Icon } from "app/NativeComponents/common";
import ManageTagsButton from "app/DealMachineCore/reuseable/ManageTagsButton";

class ManageTagsButtonWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tags: props.property?.deal?.tags || []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.property?.deal?.tags != prevProps?.property?.deal?.tags) {
      this.setState({
        tags: this.props.property?.deal.tags
      });
    }
  }

  renderTagsText(tags = []) {
    if (tags.length > 0 && Array.isArray(tags)) {
      return (
        <Wrapper
          className="deal-hover-icon"
          style={{
            alignSelf: "stretch"
          }}
        >
          <Row
            style={{
              whiteSpace: "nowrap"
            }}
          >
            <Copy>
              {tags.map((tag, i) => {
                if (i === 0) {
                  return tag.title;
                }
                return ", " + tag.title;
              })}
            </Copy>
          </Row>
        </Wrapper>
      );
    }
  }

  render() {
    const { property, colors, section, row_height } = this.props;
    const { tags } = this.state;
    return (
      <ManageTagsButton
        popoverPlacement="right"
        onLoading={({ tags }) => {
          this.setState({
            tags
          });
        }}
        renderComponent={() => {
          return (
            <Wrapper
              style={{
                position: "relative",
                width: section.width
              }}
            >
              <Wrapper
                style={{
                  width: section.width,
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }}
              >
                <Row
                  style={{
                    padding: 10,
                    paddingLeft: 10,
                    height: row_height,
                    borderRightWidth: 0,
                    borderRightColor: colors.border_color,
                    borderRightStyle: "solid",
                    justifyContent: "center"
                  }}
                >
                  <Wrapper
                    style={{
                      flex: 1,
                      alignItems: "flex-start",
                      justifyContent: "center"
                    }}
                  >
                    <Row
                      style={{
                        alignItems: "center",
                        justifyContent: "flex-start"
                      }}
                    >
                      <Wrapper>
                        <Copy
                          style={{
                            marginRight: 5,
                            color: colors.text_color
                          }}
                        >
                          {this.renderTagsText(tags)}
                        </Copy>
                      </Wrapper>
                    </Row>
                  </Wrapper>
                </Row>
              </Wrapper>
            </Wrapper>
          );
        }}
        property={property}
      />
    );
  }
}

export default ManageTagsButtonWrapper;
